<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>In loving memory of my father, Enver Emin, who played a large part in my life by showing me, by his experiences, what I should not do. For that</p>
<p>I am forever grateful.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?7939f83a